import { createContext, useContext } from 'react'

export type AuthAccess = {
  userId: string | undefined
  getHeaders: () => Promise<Record<string, string>>
}

/** 認証の実装を上位から注入し、Page/Featureから認証基盤への逆依存を防ぐ。 */
export const AuthAccessContext = createContext<AuthAccess>({
  userId: undefined,
  getHeaders: async () => {
    throw new Error('ログインが必要です。')
  },
})
export const useAuthAccess = () => useContext(AuthAccessContext)
